<template>
  <div :lang="lesson.language">
    <div class="page-title mb-5">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item text-left border-right-0 pl-3">
            <a class="nav-link" v-html="forceToJap(lesson.name) + ' - ' + lesson.localName"></a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container mb-3 pt-4 pb-4 bg-white" v-if="tab === 'player'">
      <div class="container pl-3 pr-3 text-right" style="max-width: 720px !important; min-width: 320px !important;">
        <span class="btn btn-default" @click="goTabRecord()">
          <img src="~../assets/image/icon/lesson_score_off.png" />
          <img src="~../assets/image/icon/lesson_score_on.png" v-if="false" />
        </span>
        <span class="btn btn-default" @click="$router.go(-1)">
          <img src="~../assets/image/icon/close_lesson.png" />
        </span>
      </div>

      <live-player :liveData="lesson" v-if="lesson && lesson.modules.length > 0" />
    </div>

    <div class="container mb-3 pt-4 pb-4 bg-white" v-if="tab === 'package'">
      <div class="col-12 text-right">
        <span class="btn btn-default" @click="$router.go(-1)">
          <img src="~../assets/image/icon/close_lesson.png" />
        </span>
      </div>

      <div class="text-center">
        <h2 class="h2">{{ lesson.localName }}</h2>
        <img class="mb-3" :src="lesson.cover" style="max-width: 60%; max-height: 60%;" />
        <p class="introduction" v-if="lesson.introduction">{{ lesson.introduction }}</p>
      </div>

      <ul class="nav nav-tabs mb-3">
        <li class="nav-item ml-5">
          <a class="nav-link rounded-top" :class="{ 'active': tab === 'package' }" @click="tab = 'package'">{{$t('course_list')}}</a>
        </li>
      </ul>

      <ul class="list-group">
        <li class="list-group-item text-left mb-3 border-top-0 border-left-0 border-right-0"
          v-for="(lesson, index) in lesson.lessons" :key="lesson.id">
          <div class="d-flex justify-content-between">
            <div class="align-items-baseline mr-auto">
              <b>{{ index < 9  ? '0' + (index + 1) : (index + 1) }}. {{ lesson.localName }}</b>
              <span class="ml-3" v-html="forceToJap(lesson.name)"></span>
              <p class="introduction pl-4" v-if="lesson.introduction">{{ lesson.introduction }}</p>
            </div>
            <div class="d-flex align-items-center mr-3">
              <icon-button name="more_info" :alt="$t('start_a_course')" @click.native="$router.push($router.push({ name: 'c_play', params: { lessonId: lesson.id }}))" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="container mb-3 pt-4 pb-4 bg-white" v-if="tab === 'record'">
      <div class="col-sm-12 text-right">
        <span class="btn btn-default" @click="tab = 'player'">
          <img src="~../assets/image/icon/close_lesson.png" />
        </span>
      </div>

      <div class="col-sm-12">
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item ml-5">
            <a class="nav-link rounded-top active">本課成績</a>
          </li>
        </ul>

        <ul class="list-group ml-5 mr-5">
          <li class="list-group-item d-flex justify-content-between p-0 mb-3 border-top-0 border-left-0 border-right-0">
            <div class="text-left p-3 mr-auto">
              <b>01.本課觀看累積次數 </b>
            </div>
            <div class="d-flex align-items-center mr-auto">
              累積次數：{{ record.learnCount }}
            </div>
            <div class="d-flex align-items-center">
              最後更新時間：{{ record.lastTime }}
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between p-0 mb-3 border-top-0 border-left-0 border-right-0">
            <div class="text-left p-3 mr-auto">
              <b>02.本課觀看累積時數 </b>
            </div>
            <div class="d-flex align-items-center mr-auto">
              累積時數：{{ record.spendTime }}
            </div>
            <div class="d-flex align-items-center">
              最後更新時間：{{ record.lastTime }}
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between p-0 mb-3 border-top-0 border-left-0 border-right-0" v-if="record.practiceScore">
            <div class="text-left p-3 mr-auto">
              <b>03.本課測驗成績分數 </b>
            </div>
            <div class="d-flex align-items-center mr-auto">
              {{$t('score')}}：{{ record.practiceScore }}
            </div>
            <div class="d-flex align-items-center">
              最後更新時間：{{ record.lastTime }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LivePlayer from '../components/live-player/components/LivePlayer.vue'
import langMixins from '../components/langMixin'
import api from '../store/api'
import IconButton from './Teacher/IconButton'

export default {

  name: 'LessonPlayer',

  components: {
    LivePlayer,
    IconButton
  },

  mixins: [langMixins],

  data () {
    return {
      recordTimer: null,
      tab: 'player',
      record: {}
    }
  },

  computed: {
    ...mapGetters([
      'lesson'
    ])
  },

  mounted () {
    this.$watch('$route.params.lessonId', (val, newVal) => {
      clearInterval(this.recordTimer)
      this.recordTimer = null
      this.tab = 'player'
      this.getLessonData()
      this.startRecord()
    })

    this.getLessonData()
    this.startRecord()
  },

  beforeDestroy () {
    clearInterval(this.recordTimer)
    this.recordTimer = null
  },

  methods: {
    ...mapActions([
      'getLesson'
    ]),

    async getLessonData () {
      let lessonId = this.$route.params.lessonId
      await this.getLesson(lessonId)

      if (this.lesson.lessonType === 'Package') {
        this.tab = 'package'
      }
    },

    async goTabRecord () {
      let lessonId = this.$route.params.lessonId
      const { data } = await api.get('/Lesson/' + lessonId + '/Record')

      if (data.status === 'OK') {
        this.tab = 'record'
        this.record = data.data
      }
    },

    startRecord () {
      if (this.$route.params.lessonId) {
        api.post('Lesson/' + this.$route.params.lessonId + '/Record/add')
      }

      this.recordTimer = setInterval(() => {
        api.post('Lesson/' + this.$route.params.lessonId + '/Record/update')
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-link {
    color: #000;

    &.active {
      background-color: #c2c2c2!important;
      color: #fff!important;
    }
  }

  .rounded-top {
    border-top-left-radius: 0.75rem!important;
    border-top-right-radius: 0.75rem!important;
  }

  .introduction {
    color: #5c5c5c;
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// LessonPlayer.vue?79f33589